import * as types from '../../mutation-types';
import {removeItem, addOrUpdateItem} from '../../helpers';

export default {
    // [types.SET_PROPOSAL_STATUSES_SUMMARY]: (state, proposalStatusesSummary) => Vue.set(state, 'proposalStatusesSummary', proposalStatusesSummary),
    [types.SET_PROPOSAL_STATUSES_SUMMARY]: (state, proposalStatusesSummary) => state.proposalStatusesSummary = proposalStatusesSummary,
    // [types.SET_PROPOSALS_LEAD_SOURCES]: (state, proposalsLeadSources) => Vue.set(state, 'proposalsLeadSources', proposalsLeadSources)
    [types.SET_PROPOSALS_LEAD_SOURCES]: (state, proposalsLeadSources) => state.proposalsLeadSources = proposalsLeadSources
}
